module.exports = __webpack_public_path__ + "img/download_ios.8c97ce9b.webp";